import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

export type GlobalState = {
  /** True after at least one route has emitted a GTM hit (then further routes use SPA PAGE VIEW). */
  pageVisited: boolean;
  /** Last URL key we pushed for analytics — avoids duplicate hits on the same route (e.g. Strict Mode). */
  lastTrackedUrl: string | null;
};

const initialState: GlobalState = {
  pageVisited: false,
  lastTrackedUrl: null,
};

export const globalSlice = createSlice({
  name: "global",
  initialState,
  reducers: {
    /** Call after each successful `PushDataToGTM` for route analytics. */
    setPageAnalytics(state, action: PayloadAction<string>) {
      state.lastTrackedUrl = action.payload;
      state.pageVisited = true;
    },
  },
});

export const { setPageAnalytics } = globalSlice.actions;
export default globalSlice.reducer;
